import template from './pageContent.html';

export const PageContentModule = angular
    .module('app.components.pageContent', [])
    .component('pageContent', {
        template,
        bindings: {
            noTouch: '<'
        },
        transclude: true
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/components/pageContent/pageContent.module.js